// 手机号正则
export const phoneNum = /^((1)|(\\+861)|(861))[0-9]{10}$/;

// 邮箱正则
export const email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

// export const http = "https://www.decaisoft.com:443/";
// export const https = "https://www.decaisoft.com:443/img";

export const http = "http://110.41.6.1:21/img/";
export const https = "http://110.41.6.1:8077/tydFile/";

var month = "";
if (new Date().getMonth() + 1 < 10) {
  month = "0" + (new Date().getMonth() + 1);
} else {
  month = new Date().getMonth() + 1;
  // dabao;
}

var day = "";
if (new Date().getDate() < 10) {
  day = "0" + new Date().getDate();
} else {
  day = new Date().getDate();
}

var hours = "";
if (new Date().getHours() < 10) {
  hours = "0" + new Date().getHours();
} else {
  hours = new Date().getHours();
}

var Min = null;
if (new Date().getMinutes() < 10) {
  Min = "0" + new Date().getMinutes();
} else {
  Min = new Date().getMinutes();
}
var seconds = null;
if (new Date().getSeconds() < 10) {
  seconds = "0" + new Date().getSeconds();
} else {
  seconds = new Date().getSeconds();
}

export const date =
  new Date().getFullYear() +
  "" +
  month +
  "" +
  day +
  "" +
  hours +
  "" +
  Min +
  "" +
  seconds;
export const dates =
  new Date().getFullYear() +
  "/" +
  month +
  "/" +
  day +
  " " +
  hours +
  ":" +
  Min +
  ":" +
  seconds;

export const dayStatisticDate =
  new Date().getFullYear() + "-" + month + "-" + new Date().getDate();
export const months = new Date().getFullYear() + "-" + month + "";



//////////////////
// WEBPACK FOOTER
// ./partten/partten.js
// module id = null
// module chunks = 